
export const API_URL = "https://study.studyexpressgroup.com.np/api";

export const IMG_URL = "https://study.studyexpressgroup.com.np/";
